module.exports = __webpack_public_path__ + "media/audio12.7daffbb6.mp4";